// Optional UPC scan on the pick modal (issue #4181, demo config only).
//
// The field is purely client-side: the scanned UPC is shown to the operator but
// never validated against the SKU and never sent in any API payload. It can be
// scanned once per pick task; the quantity is still adjusted with +/-.
//
// Enabled by REACT_APP_ENABLE_UPC_SCAN, which the deploy workflow stamps into the
// Operator UI .env file from the `OperatorUiEnableUpcScan` config override.

const TRUTHY_VALUES = ["true", "1", "yes", "on"];

export function isUpcScanEnabled(value?: string): boolean {
  if (!value) {
    return false;
  }

  return TRUTHY_VALUES.includes(value.trim().toLowerCase());
}

/** Trimmed scan value, or null when the scan was blank (nothing to lock in). */
export function normalizeUpcScan(raw?: string | null): string | null {
  const value = String(raw ?? "").trim();
  return value ? value : null;
}
